<template>
        <div class="container">
            <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
                <ul v-if="laptop">
                    <li>
                        <router-link to="/">Главная</router-link>
                    </li>
                    <li>
                        <router-link :to="'/' + laptop.brand.slug+ '-noutbuki'">{{ laptop.brand.name }}</router-link>
                    </li>
                    <li class="is-active">
                        <router-link to="#" aria-current="page">{{ laptop.category.name }} {{ laptop.brand.name }} в Ташкенте
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>
</template>
<script>
    export default {
        name: "BreadCrumb",
        props: ['laptop',],
    }
</script>

<style scoped>

</style>
